import { useState, useEffect } from "react";
import type { Goal, DbGoal } from "@/types/goal";
import type { RealtimePostgresChangesPayload } from "@supabase/supabase-js";
import { goalService, convertToAppGoal } from "../services/goalService";

export const useGoal = (goalId: string | undefined) => {
	const [goal, setGoal] = useState<Goal | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		if (!goalId) {
			setLoading(false);
			return;
		}

		const fetchGoal = async () => {
			try {
				const data = await goalService.getGoalById(goalId);
				setGoal(data);
			} catch (err) {
				setError(err as Error);
			} finally {
				setLoading(false);
			}
		};

		fetchGoal();

		// リアルタイム更新のサブスクリプション
		const subscription = goalService.subscribeToChanges(
			(payload: RealtimePostgresChangesPayload<DbGoal>) => {
				if (payload.eventType === "UPDATE" && payload.new.id === goalId) {
					setGoal(convertToAppGoal(payload.new));
				}
			},
		);

		return () => {
			subscription.unsubscribe();
		};
	}, [goalId]);

	return { goal, loading, error };
};
